<svelte:options tag={null} />

<script lang="ts">
  import { EventHandler } from '../../utilities/EventHandler';

  export let name: string;
  export let checked: boolean;
  export let indeterminate: boolean;
  export let disabled = false;
  export let isinvalid = false;
  export let label: string;
  $: isChecked = checked ? true : false;
  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;
  let eventHandler = new EventHandler();

  function handleChange(): void {
    isChecked = !isChecked;
    eventHandler.dispatch('change', isChecked);
  }
</script>

<div class="mc-checkbox {userClass}" {...attributes}>
  <input
    id={name}
    type="checkbox"
    class="mc-checkbox__input {isinvalid ? ' is-invalid' : ''}"
    aria-invalid={isinvalid}
    {name}
    {checked}
    {disabled}
    {indeterminate}
    on:change={handleChange}
  />
  {#if label}
    <label for={name} class="mc-checkbox__label">{label}</label>
  {/if}
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.checkbox';
  @import '@mozaic-ds/styles/components/c.fields';
</style>
